export let CHANNEL_VIDEO_LIST_VALUES = /*#__PURE__*/function (CHANNEL_VIDEO_LIST_VALUES) {
  CHANNEL_VIDEO_LIST_VALUES[CHANNEL_VIDEO_LIST_VALUES["EXPAND_ON_CLICK"] = 1] = "EXPAND_ON_CLICK";
  CHANNEL_VIDEO_LIST_VALUES[CHANNEL_VIDEO_LIST_VALUES["ALWAYS_SHOW"] = 2] = "ALWAYS_SHOW";
  CHANNEL_VIDEO_LIST_VALUES[CHANNEL_VIDEO_LIST_VALUES["NEVER_SHOW"] = 3] = "NEVER_SHOW";
  return CHANNEL_VIDEO_LIST_VALUES;
}({});
//# sourceMappingURL=channel-video-list-values.js.map